import client from '@/lib/axios-client'
import type {
	UpdateRoleRequest,
	UpdateStatusRequest,
	UserOutput,
	UsersListParams,
	UsersListResponse,
} from '@/types/auth'

const USERS_URL = '/users'

export async function getUsers(
	params?: UsersListParams,
): Promise<UsersListResponse> {
	const response = await client.get(USERS_URL, { params })
	return response.data.data
}

export async function getUserById(id: string): Promise<UserOutput> {
	const response = await client.get(`${USERS_URL}/${id}`)
	return response.data.data
}

export async function updateUserRole(
	id: string,
	data: UpdateRoleRequest,
): Promise<UserOutput> {
	const response = await client.patch(`${USERS_URL}/${id}/role`, data)
	return response.data.data
}

export async function updateUserStatus(
	id: string,
	data: UpdateStatusRequest,
): Promise<UserOutput> {
	const response = await client.patch(`${USERS_URL}/${id}/status`, data)
	return response.data.data
}

export async function resetUserPassword(id: string): Promise<void> {
	await client.put(`${USERS_URL}/${id}/reset-password`)
}

export async function deleteUser(id: string): Promise<void> {
	await client.delete(`${USERS_URL}/${id}`)
}
